import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgHydratingMaskGlyph from './svgs/HydratingMaskGlyph.js';
import { useIcon } from '../../shared-components/icon/index.js';

var hydratingMaskGlyph = (props => useIcon(SvgHydratingMaskGlyph, SvgHydratingMaskGlyph, props));

export { hydratingMaskGlyph as default };
